import React, { useState } from "react";
import "./Settings.css";

import Organization from "./sections/Organization";
import Billing from "./sections/Billing";
import Security from "./sections/Security";
import Api from "./sections/Api";
import Integrations from "./sections/Integrations";
import Appearance from "./sections/Appearance";
import DataExport from "./sections/DataExport";
import Danger from "./sections/Danger";

const TABS = [
  "organization",
  "billing",
  "security",
  "api",
  "integrations",
  "appearance",
  "data",
  "danger",
];

export default function Settings() {
  const [active, setActive] = useState("organization");
  const [busy, setBusy] = useState(false);
  const [toast, setToast] = useState("");

const [org, setOrg] = useState({
  name: "JKumar Safety",
  slug: "jkumar",
  address: "Delhi, IN",
  domain: "jkumar.example.com",
});

const [sec, setSec] = useState({
  mfa: true,
  sessions: 5,
  sso: false,
});

const [apiObj, setApiObj] = useState({
  key: "sk-live-••••••••••••••••••••••",
  webhooks: [
    { url: "https://example.com/hooks/jkumar", secret: "whsec_••••••" },
  ],
});

const [theme, setTheme] = useState({
  mode: "system", // light | dark | system
  accent: "#2563eb",
  compact: false,
});

const [dataPrefs, setDataPrefs] = useState({
  exportFormat: "csv",
  includeImages: false,
  redactEmails: true,
});


  const save = async (label, fn = async () => {}) => {
    setBusy(true);
    try {
      await fn();
      setToast(`${label} saved`);
      setTimeout(() => setToast(""), 1500);
    } finally {
      setBusy(false);
    }
  };

  const panels = {
    organization: <Organization org={org} setOrg={setOrg} busy={busy} save={save} />,
    billing: <Billing busy={busy} save={save} />,
    security: <Security sec={sec} setSec={setSec} busy={busy} save={save} />,
    api: <Api api={apiObj} setApi={setApiObj} busy={busy} save={save} />,
    integrations: <Integrations />,
    appearance: <Appearance theme={theme} setTheme={setTheme} busy={busy} save={save} />,
    data: <DataExport dataPrefs={dataPrefs} setDataPrefs={setDataPrefs} busy={busy} save={save} />,
    danger: <Danger org={org} busy={busy} save={save} />,
  };

  return (
    <div className="settings-wrap">
      <aside className="settings-aside">
        <h2 className="set-title">Settings</h2>
        <nav className="set-nav">
          {TABS.map((t) => (
            <button key={t} className={`set-tab ${active === t ? "active" : ""}`} onClick={() => setActive(t)}>
              {t.charAt(0).toUpperCase() + t.slice(1)}
            </button>
          ))}
        </nav>
      </aside>

      <main className="settings-main">
        {toast && <div className="set-toast">{toast}</div>}
        {panels[active]}
      </main>
    </div>
  );
}
